import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import style from '../../../scss/components/buttons/button.module.scss';
import { MessageContext } from '../../Framework/Context/MessageContext';
import axiosInstance from '../../Services/axios';

const APP_URL = import.meta.env.VITE_APP_URL;

const PreviewButton = ({ entity }) => {
    const [loading, setLoading] = useState(false);
    const { pushMessage } = useContext(MessageContext);

    const handlePreview = async () => {
        if (!entity?.slug) {
            pushMessage({
                title: 'Save the article first to generate a slug.',
            });
            return;
        }

        setLoading(true);
        try {
            const $articleId = entity.id;
            const response = await axiosInstance.get(
                `${APP_URL}admin/articles/${$articleId}/preview`,
            );

            if (response.status === 200) {
                window.open(response.data.url, '_blank');
            }
        } catch (exception) {
            pushMessage({
                title: 'Failed to open preview.',
                message: exception.message,
            });
        } finally {
            setLoading(false);
        }
    };

    if (!entity.is_draft) {
        return null;
    }

    return (
        <button
            className={`${style.basic}`}
            type="button"
            onClick={handlePreview}
            disabled={loading}
        >
            {loading ? 'Opening preview…' : 'Preview'}
        </button>
    );
};

PreviewButton.propTypes = {
    entity: PropTypes.object.isRequired,
};

export default PreviewButton;
